import { Injectable, inject } from '@angular/core';
import { ActionDef, Store } from '@ngxs/store';
import { ResetOrderAction } from '@sales/states/order/order.actions';
import {
  ProductResetAction,
  ResetSelectedSubscriptionAction,
} from '@sales/states/customer-product/customer-product.actions';
import { Product, ProductStartIndex } from '@app/shared/models/product.model';
import { LogisticsResetAction } from '@sales/states/logistics/logistics.actions';
import { CustomerResetAction } from '@sales/modules/details/states/customer.actions';
import {
  MbbProductResetAction,
  ResetSelectedMbbSubscriptionAction,
} from '@sales/modules/mbb/states/customer-product-mbb.actions';
import { ContractResetAction } from '@sales/states/contract/contract.actions';
import { FormResetAction } from '@sales/states/form/form.actions';
import { OrderCaptureResetAction } from '@sales/states/order-capture/order-capture.actions';
import { AccessoryProductResetAction } from '@sales/states/accessory-product/accessory-product.actions';
import { ResetMobilePhoneProductState } from '@sales/states/customer-product-mobilephone/customer-product-mobilephone.actions';
import { OfferingResetAction } from '@sales/states/offering/offering.actions';
import { MBBOfferingResetAction } from '@sales/states/offering-mbb/offering-mbb.actions';
import { ResetFamilyStateAction } from '@sales/states/family/family.actions';
import { ResetCustomerSearchAction } from '@core/states/customer-search/customer-search.actions';
import { ResetSaleStatusAction } from '@sales/states/sale/sale.actions';
import { CustomerServiceProductResetAction } from '@sales/states/customer-service-product/customer-service-product.actions';
import { TradeInProductResetAction } from '@app/sales/states/customer-product-trade-in/customer-product-trade-in.actions';
import { ResetMobilBytteState } from '@app/sales/modules/mobilephone/states/mobilbytte/mobilbytte.actions';
import { CompetitionResetAction } from '@support/states/competition/competition.actions';

@Injectable({
  providedIn: 'root',
})
export class StateHelperService {
  private store = inject(Store);

  public resetSaleState(resetExemptions: ActionDef[] = []): void {
    const allResetActionClasses = [
      ResetSelectedSubscriptionAction,
      ResetSelectedMbbSubscriptionAction,
      CustomerResetAction,
      ResetOrderAction,
      ProductResetAction,
      MbbProductResetAction,
      AccessoryProductResetAction,
      TradeInProductResetAction,
      ContractResetAction,
      OrderCaptureResetAction,
      LogisticsResetAction,
      FormResetAction,
      ResetMobilePhoneProductState,
      ResetMobilBytteState,
      ResetSaleStatusAction,
      OfferingResetAction,
      MBBOfferingResetAction,
      ResetFamilyStateAction,
      ResetCustomerSearchAction,
      CustomerServiceProductResetAction,
      CompetitionResetAction,
    ];

    const filteredResetActions = allResetActionClasses
      .filter(actionClass => !resetExemptions.includes(actionClass))
      .map(actionClass => new actionClass());

    this.store.dispatch(filteredResetActions);
  }

  public getIncrementedProductId(products: Product[], startIndex: number = ProductStartIndex.Voice): string {
    let count = products.length + startIndex;
    while (products.find(p => p.id === String(count))) {
      count++;
    }

    return String(count);
  }
}
